export default "__VITE_ASSET__Bmevk4uN__"